import type { ReactNode } from 'react'

type SurfaceCardProps = {
    title?: string
    description?: string
    children: ReactNode
    padded?: boolean
}

export const SurfaceCard = ({ title, description, children, padded = true }: SurfaceCardProps) => {
    return (
        <section className="border-account-divider bg-account-surface overflow-hidden rounded-xl border shadow-sm">
            {(title || description) && (
                <div className="border-account-divider border-b px-4 py-4 sm:px-6 sm:py-5">
                    {title && <h2 className="text-account-strong text-lg font-bold">{title}</h2>}
                    {description && <p className="text-account-secondary mt-1 text-sm">{description}</p>}
                </div>
            )}
            <div className={padded ? 'p-4 sm:p-6' : undefined}>{children}</div>
        </section>
    )
}
